/* eslint-disable */
export async function MensagensProntasAgendamentoAutorizado(
  nm_paciente,
  ds_item_agendamento
) {
  return `Sr(a) ${nm_paciente}, sou a Paula, assistente virtual do Hospital Paulista, tudo bem?\n\nInformo que seu agendamento de ${ds_item_agendamento}, está autorizado.\n\nReforço que na data de seu atendimento é necessário chegar ao Hospital com antecedência de 30 minutos e trazer: Documento com foto, CPF, cartão do convênio e pedido médico original.\n\nEstamos situado na Rua Dr. Diogo de Faria,780.\n\nhttps://goo.gl/maps/fECFGdpnjfMggfHq9\n\nSe vier de metrô as estações mais próximas são:\n\nHospital São Paulo\nMetro Santa Cruz.`
}
